import axios from "axios";
import { API_MODESETTINGS_URL } from "../config";
import { OnboardingSave } from "../interfaces/onboarding";
import { RootState } from "../reducers/store";
import { createHttpHeaderWithAuthorization } from "../services/http-header";

const b64toBlob = (b64Data: string, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data.split(";base64,")[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
};

export const saveOnboarding = (
    bodyRequest: OnboardingSave,
    fromTrialToFull: boolean,
) => {
    return (dispatch: any, getState: () => RootState) => {
        return new Promise(function (resolve, reject) {
            const main = getState().main;
            const itemId = main.companyUuid || main.accountantUuid;
            const formData = new FormData();

            let subjectRequest: any = {
                expiringDate: bodyRequest?.expiringDate,
                name: bodyRequest?.firstName,
                surname: bodyRequest?.lastName,
                fiscal_code: bodyRequest?.fiscalCode,
            };

            const subjectRequestBlob = new Blob(
                [JSON.stringify(subjectRequest)],
                {
                    type: "application/json",
                },
            );

            formData.append("subjectRequest", subjectRequestBlob);
            formData.append("front", b64toBlob(bodyRequest?.frontDoc));
            formData.append("back", b64toBlob(bodyRequest?.backDoc));
            dispatch({ type: "SAVE_ONBOARDING_START" });
            axios
                .post(
                    `${API_MODESETTINGS_URL}/api/v1/${itemId}/subject`,
                    formData,
                    {
                        headers: {
                            ...dispatch(
                                createHttpHeaderWithAuthorization(true),
                            ),
                            "Content-Type": "multipart/form-data",
                        },
                    },
                )
                .then((result) => {
                    axios
                        .post(
                            `${API_MODESETTINGS_URL}/api/v1/${itemId}/consent`,
                            {
                                acceptGenericTerms:
                                    bodyRequest?.acceptGenericTerms ||
                                    fromTrialToFull,
                                acceptSpecificClauses:
                                    bodyRequest?.acceptSpecificClauses ||
                                    fromTrialToFull,
                                acceptMarketing:
                                    bodyRequest?.acceptMarketing || false,
                                acceptShareData:
                                    bodyRequest?.acceptShareData || false,
                            },
                            {
                                headers: {
                                    ...dispatch(
                                        createHttpHeaderWithAuthorization(true),
                                    ),
                                },
                            },
                        )
                        .then((result2) => {
                            dispatch({
                                type: "SAVE_ONBOARDING_SUCCESS",
                                payload: result2.data,
                            });
                            resolve(result2.data);
                        })
                        .catch((e) => {
                            dispatch({ type: "SAVE_ONBOARDING_ERROR" });
                            reject(e);
                        });
                })
                .catch((e) => {
                    dispatch({ type: "SAVE_ONBOARDING_ERROR" });
                    reject(e);
                });
        });
    };
};

export const searchSubjects = () => {
    return (dispatch: any, getState: () => RootState) => {
        return new Promise(function (resolve, reject) {
            const main = getState().main;
            const itemId = main.companyUuid || main.accountantUuid;
            dispatch({ type: "SEARCH_SUBJECTS_START" });
            axios
                .get(`${API_MODESETTINGS_URL}/api/v1/${itemId}/details`, {
                    headers: dispatch(createHttpHeaderWithAuthorization(true)),
                })
                .then((result) => {
                    dispatch({
                        type: "SEARCH_SUBJECTS_SUCCESS",
                        payload: result.data,
                    });
                    resolve(result.data);
                })
                .catch((e) => {
                    dispatch({ type: "SEARCH_SUBJECTS_ERROR" });
                    reject(e);
                });
        });
    };
};
